export default __webpack_public_path__ + "static/media/attila-licking-twokitty.1f6064d4.png";